import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import MovieCard from '../components/MovieCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUpload, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { toJpegFile } from '../utils/imageFile';
import './HomePage.css';
import './SearchPage.css';

function SearchPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/movies/search_movie/${searchQuery}`);
      setSearchResults(response.data);
    } catch (error) {
      console.error('Error searching for movies:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = '';
    if (!file) return;
    setLoading(true);
    try {
      const jpeg = await toJpegFile(file);
      const formData = new FormData();
      formData.append('file', jpeg);
      const response = await axios.post('/api/movies/imagesearch', formData, {
        timeout: 120000,
      });
      setSearchResults(response.data || []);
    } catch (error) {
      console.error('Error searching for movies with image:', error);
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="search-page">
      <div className="search-bar-wrapper">
        <div className="search-bar">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            placeholder="Search for movies..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button onClick={handleSearch} className="search-submit-button" title="Search">
            <FontAwesomeIcon icon={faSearch} />
          </button>
          <button onClick={triggerFileInput} className="upload-button" title="Search by image">
            <FontAwesomeIcon icon={faUpload} />
          </button>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleImageUpload}
            className="search-file-input"
          />
        </div>
        <Link to="/search-qr" className="kiosk-link-button" title="Fair booth QR search">
          <FontAwesomeIcon icon={faQrcode} />
        </Link>
      </div>
      {loading ? (
        <p className="page-loading">Loading...</p>
      ) : searchResults.length > 0 ? (
        <div className="home-page">
          <div className="genre-section">
            <div className="movie-grid-wrapper">
              <div className="movie-grid wrap">
                {searchResults.map((movie) => (
                  <MovieCard key={movie.movieid} movie={movie} />
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p className="search-empty">Use the bar above to search by title or image.</p>
      )}
    </div>
  );
}

export default SearchPage;
